import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import CustomControl from '../../../../../../../../../components/global/CustomControl';
import { IMAGE_SIZE_CODE } from '../../../../../../../../../constants/image-size-codes';
import { getThumbBySize } from '../../../../../../../../../util/photo';

const propTypes = {
  photo: PropTypes.shape({
    id: PropTypes.string.isRequired,
    thumbnail_urls: PropTypes.arrayOf(
      PropTypes.shape({
        url: PropTypes.string,
        size_code: PropTypes.oneOf(Object.values(IMAGE_SIZE_CODE)),
      }),
    ),
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
  selected: PropTypes.bool,
  className: PropTypes.string,
  isSingleGrid: PropTypes.bool,
};

const PhotoSelect = ({
  photo,
  onSelect,
  selected,
  className,
  isSingleGrid,
}) => {
  const classes = classNames({
    'slideshow-photo-select': true,
    'is-selected': selected,
    [className]: !!className,
  });

  return (
    <a
      className={classes}
      href="#"
      onClick={event => {
        event.preventDefault();
        onSelect(photo);
      }}
    >
      <CustomControl
        id={photo.id}
        label="Photo Selected"
        labelSrOnly
        type="checkbox"
        checked={selected}
        size={isSingleGrid ? 'lg' : 'md'}
        readOnly
      />

      <img
        src={getThumbBySize(photo.thumbnail_urls, IMAGE_SIZE_CODE.MEDIUM)?.url}
        alt=""
      />
    </a>
  );
};

PhotoSelect.propTypes = propTypes;

export default PhotoSelect;
